import { Fetch } from 'lib';
import type { ShippingConfigSortType, ShippingConfigSummary } from 'types';

type RequestResponses = {
  total: number;
  data: ShippingConfigSummary[];
};

type RequestParameters = {
  sortType: ShippingConfigSortType;
  searchKey: string;
  pageSize: number;
  pageNumber: number;
};

const searchShippingConfigs = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminShippingConfig/searchShippingConfigs',
    params,
  });

export { searchShippingConfigs };
